import { IconAtom2Outline18 as AtomIcon } from "nucleo-ui-outline-18"

import { Button, CopyButton } from "@productlane/ui"

import { MetaInfo } from "@/components/meta-info"
import { toast } from "@/components/toast"
import { useZeroWorkspace } from "@/lib/zero"
import { SettingsHeader } from "../../settings-header"
import { SettingItem } from "../../settings-switches/setting-item"
import { SettingsContainer } from "../../settings-switches/settings-container"
import { ApiActivityBlock } from "./api-activity/api-activity-block"
import { ApiAnalyticsBlock } from "./api-analytics/api-analytics-block"
import { ApiKeysBlock } from "./api-keys/api-keys-block"
import { LegacyApiKeysBlock } from "./api-keys/legacy-api-keys-block"
import { ConnectedAppsBlock } from "./connected-apps/connected-apps-block"
import { WebhooksBlock } from "./webhooks/webhooks-block"

const API_TITLE = "API"
const API_DESCRIPTION =
	"Sync your contacts, conversations and more with the API."

export function ApiIntegrationsPage() {
	const workspace = useZeroWorkspace()
	if (!workspace) return null

	return (
		<>
			<MetaInfo title="API Integration" />
			<SettingsHeader
				title={API_TITLE}
				subtitle={API_DESCRIPTION}
				action={
					<a
						href="https://productlane.com/docs/api"
						target="_blank"
						rel="noreferrer"
					>
						<Button variant="outline" Icon={AtomIcon}>
							How it works
						</Button>
					</a>
				}
			/>

			<SettingsContainer>
				<SettingItem
					title="Workspace ID"
					description="Your Workspace ID to interact with the API."
					action={
						<CopyButton
							value={workspace.id}
							text={workspace.id}
							className="border border-gray-200 font-mono text-xs hover:bg-gray-100 dark:border-gray-700 dark:hover:bg-gray-800"
							onCopied={() => toast.success({ title: "Workspace ID copied" })}
						/>
					}
				/>
			</SettingsContainer>

			<ApiKeysBlock />
			<WebhooksBlock />
			<ConnectedAppsBlock />
			<ApiAnalyticsBlock />
			<ApiActivityBlock />
			<LegacyApiKeysBlock />
		</>
	)
}
